/**
 * PRJ1417943_IntergrationAccelerator - Centralized agency configuration - single source of truth for all agency metadata
 * Used by: agencyData, validation rules/errors, payments, mock-server, link services
 * Fields: agencyId, agencyCode, agencyShortName (slug/routing),
 * importPath (enables dynamic loading), applicationCodes (app code → slug mapping)
 */
const agencies = [
  {
    agency: {
      agencyId: 'A2',
      agencyName: 'Board of Nursing',
      agencyCode: '16',
      agencyShortName: 'BON',
      importPath: './BON',
      applicationCodes: {
        '27': 'bnlr',
      },
    },
  },
  {
    agency: {
      agencyId: '2',
      agencyName: 'Texas Department of Licensing and Regulation',
      agencyCode: '452',
      agencyShortName: 'TDLR',
      importPath: './TDLR',
      applicationCodes: {
        TDLR_LR: 'tdlrlr',
      },
    },
  },
  {
    agency: {
      agencyId: '9',
      agencyName: 'Texas Department of Motor Vehicles',
      agencyCode: '608',
      agencyShortName: 'DMV',
      importPath: './DMV',
      applicationCodes: {
        DMV_RR: 'dmvrr',
      },
    },
  },
  {
    agency: {
      agencyId: '10',
      agencyName: 'Texas Department of Public Safety',
      agencyCode: '405',
      agencyShortName: 'DPS',
      importPath: './DPS',
      applicationCodes: {
        DLR: 'dpslr',
      },
    },
  },
  {
    agency: {
      agencyId: '13',
      agencyName: 'Texas Parks and Wildlife Department',
      agencyCode: '802',
      agencyShortName: 'TPWD',
      importPath: './TPWD',
      applicationCodes: {
        TPWD_AS: 'tpwdas',
      },
    },
  },
];

// CommonJS export for compatibility with both ES6 imports and require() (used by mock-server)
module.exports = agencies;